import { render, staticRenderFns } from "./PrivateProtect.vue?vue&type=template&id=183f8e9c&"
import script from "./PrivateProtect.vue?vue&type=script&lang=js&"
export * from "./PrivateProtect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports